






































































import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { DynamicScroller } from 'vue-virtual-scroller';
const dynamic = ['createUser', 'createSuperior'];
@Component({
	components: {
		DynamicScroller,
	},
})
export default class extends Vue {
	@Prop({ default: () => ({}) }) public item!: any;
	@Prop({ default: () => ({}) }) public form!: any;
	private deps: any = [];
	private indexBar: any = [];
	private popupValueArr: any = [];
	private searchValue = '';
	private showPicker = false;
	private get currentSelect() {
		const deptList = this.deptList[0].children;
		return this.recursion(this.popupValueArr, deptList);
	}
	// 深度优先递归
	private recursion(popupValueArr, arr) {
		let selArr: any = [];
		arr.forEach((item) => {
			if (popupValueArr.includes(item.id)) {
				selArr.push(item);
			}
			if (item.children) {
				selArr = selArr.concat(this.recursion(popupValueArr, item.children));
			}
		});
		return selArr;
	}
	private jumpTo(item, index) {
		if (index === this.indexBar.length - 1) {
			return;
		}
		this.searchValue = '';
		this.deps = item.children;
		this.indexBar = this.indexBar.slice(0, index + 1);
	}

	private get deptList() {
		let obj = { ...AppModule.deptList[0] };
		obj.departmentName = '全部部门';
		return [obj];
	}
	private get filterDeps() {
		return this.deps.filter((item) => {
			if (item.departmentName.includes(this.searchValue)) {
				return true;
			}
		});
	}
	private cancel() {
		this.showPicker = false;
		this.popupValueArr = [];
		this.form.filterValue = '';
		this.$emit('change');
	}
	private close(item) {
		// 转化为字符串
		let id = +item.id;
		let index = this.popupValueArr.indexOf(id);
		this.popupValueArr.splice(index, 1);
	}
	// 选中二级目录
	private changIndex(item) {
		if (item.children) {
			this.searchValue = '';
			this.deps = item.children;
			this.indexBar.push(item);
		}
	}
	// 确定
	private comfirm() {
		console.log(this.popupValueArr);
		this.form.filterValue = this.popupValueArr.join(',');
		this.showPicker = false;
		this.$emit('change');
	}

	private open() {
		this.showPicker = true;
		this.deps = this.deptList[0].children;
		this.indexBar = [this.deptList[0]];
	}
	private clear() {
		this.popupValueArr = [];
	}
	@Watch('$route.params.viewId')
	private ChildChanged() {
		this.popupValueArr = '';
	}
}
